export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/qa_review.fbcccfa.svg";